








































































































































import { Roles } from '@/utils/roles.constant'
import { filterMixin } from '@/utils/mixins/filterMixin'
import { topUpStatus } from '@/utils/topUpStatus.constant'
import RangeDatePicker from '@/components/RangeDatePicker.vue'
import { DatePicker, Params } from '@/utils/interfaces'
import { chipClasses } from '@/utils/chipClasses.constant'
import { getProviders, getSharedProviders } from '@/api/Topup/topup.api'
import { getAgencies } from '@/api/Agency/agency.api'
import Autocomplete from '@/components/Autocomplete.vue'
import UserListItem from '@/components/UserListItem.vue'
import { getUsers } from '@/api/Users/users.api'
import FlatFilter from '~/components/FlatFilter.vue'

export default filterMixin.extend({
  components: {
    appRangeDatePicker: RangeDatePicker,
    appAutocomplete: Autocomplete,
    appUsersListItem: UserListItem,
    FlatFilter,
  },
  data() {
    return {
      roles: Roles,
      status: topUpStatus.map(status => ({
        value: status,
        text: this.$t(status),
      })),
      statusClass: topUpStatus,
      chipClasses: chipClasses,
      getProviders: getProviders,
      getSharedProviders: getSharedProviders,
      getAgents: (params?: Params) =>
        getUsers({ ...params, services__name: 'TOP-UP' }),
      getAgencies: getAgencies,
      tags: [this.$t('yours'), this.$t('of-network')],
      integrations: [this.$t('yours'), this.$t('of-integration')],
      searchTerms: [
        this.$t('phone-number'),
        this.$t('carrier_trans_id'),
        this.$t('client-name'),
      ],
      owner: 0,
    }
  },
  methods: {
    newFilter() {
      const dates = (this.$refs.datePicker as DatePicker).getData()
      const filter = {
        ...this.filter,
        topup__created_at__gte: dates.minDate,
        topup__created_at__lte: dates.maxDate,
      } as { [key: string]: any }
      switch (this.owner) {
        case 1:
          filter.from_agent__uuid = this.$store.getters.profile.uuid
          break
        case 2:
          filter.not_from_agent = this.$store.getters.profile.uuid
          if (this.$store.getters.profile.role === 'ADMIN') {
            filter.chain_type = 'AGENCY'
          }
          break

        default:
          break
      }
      if (filter.chain_type === 'AGENCY' && filter.from_agent__uuid) {
        filter.agent__uuid = filter.from_agent__uuid
        filter.from_agent__uuid = undefined
      }
      this.$emit('filter', filter)
    },
  },
  created() {
    ;(this.filter as { integration: boolean }).integration = false
  },
})
